// BasesAnalyzeService.js — client callable for base NL analyze (Ai / Capture)

import { httpsCallable } from 'firebase/functions';

import { functions } from 'firebaseConfig';
import { buildTenantCallableFields } from 'utilities/basePersistence';

const basesAnalyzeCallable = httpsCallable(functions, 'basesAnalyze');

export async function requestBasesAnalyze({
  baseKey,
  channelKey,
  userMessageKey,
  question,
  scopeHint = { mode: 'base', typeId: null },
  timeZone = null,
  captureOrigin = false,
  threadRootKey = '',
  mentionKeys = [],
  selectedNodeKey = '',
} = {}) {
  const response = await basesAnalyzeCallable({
    ...buildTenantCallableFields(baseKey),
    channelKey,
    userMessageKey,
    question,
    scopeHint,
    timeZone: timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC',
    captureOrigin: captureOrigin === true,
    threadRootKey: String(threadRootKey || '').trim() || undefined,
    mentionKeys: Array.isArray(mentionKeys)
      ? mentionKeys.map((key) => String(key || '').trim()).filter(Boolean)
      : [],
    selectedNodeKey: String(selectedNodeKey || '').trim() || undefined,
  });

  return response?.data || null;
}
